var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataCollection)?_c('doughnut-chart',{attrs:{"data":_vm.dataCollection,"options":_vm.options,"height":_vm.height}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }